import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { InteractionType, KeyValues3, LocalService, Status, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';

@Component({
  selector: 'app-new-complaint',
  templateUrl: './new-complaint.component.html',
  styleUrls: ['./new-complaint.component.scss']
})
export class NewComplaintComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["complaints"]; data: KeyValues3 = { key: '', v1: '', v2: '', v3: '' } as KeyValues3;
  interactionType: InteractionType = InteractionType.None; logId = ''; maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private activeModal: NgbActiveModal, private profileManagementService: ProfileManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.data = { key: '', v1: this.logId, v2: '', v3: this.interactionType == InteractionType.User ? '1' : '0' } as KeyValues3;
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onAdd() {
    if (this.data.v2.trim() != '') {
      if (this.logId == '') {
        this.profileManagementService.newComplaint(this.data).subscribe(result => {
          if (result.status == Status.Success) {
            this.activeModal.close({ event: TriggeredEvent.Ok });
          }
        });
      } else {
        this.profileManagementService.newComplaintDetail(this.data).subscribe(result => {
          if (result.status == Status.Success) {
            this.activeModal.close({ event: TriggeredEvent.Ok });
          }
        });
      }
    }
  }

}
